
import { supabase } from '../client';
import { Product } from './types';

export const addProduct = async (
  productData: Partial<Product>, 
  organizationId: string,
  shopId?: string
): Promise<Product | null> => {
  try {
    // Create a sanitized version of product data for logging
    const logSafeData = {
      name: productData.name,
      price: productData.price,
      shop_id: shopId || null,
      organization_id: organizationId,
      form_id: productData.form_id,
      media_urls_count: Array.isArray(productData.media_urls) ? productData.media_urls.length : 0
    };
    
    console.log('[addProduct] Adding product with data:', logSafeData);
    
    // Check and prepare media_urls - ensure it's a valid array with only valid string URLs
    let safeMediaUrls: string[] = [];
    
    if (productData.media_urls !== undefined) {
      if (!Array.isArray(productData.media_urls)) {
        console.error('[addProduct] media_urls is not an array:', productData.media_urls);
        productData.media_urls = [];
      } else {
        // Log the original URLs for debugging
        console.log('[addProduct] Image URLs before filtering:', productData.media_urls);
        
        // Filter invalid URLs and convert any non-string values to strings where possible
        safeMediaUrls = productData.media_urls
          .filter(url => url !== null && url !== undefined)
          .map(url => String(url))
          .filter(url => url.trim() !== '');
        
        productData.media_urls = safeMediaUrls;
        console.log('[addProduct] Filtered image URLs for insertion:', safeMediaUrls);
      }
    } else {
      console.log('[addProduct] media_urls is not defined, initializing to []');
      productData.media_urls = [];
    }
    
    // Create a clean product object
    const product = {
      name: productData.name || '',
      overview: productData.overview,
      description: productData.description || '',
      price: Number(productData.price) || 0,
      discount_price: productData.discount_price,
      sku: productData.sku === '' ? null : productData.sku,
      stock_quantity: productData.stock_quantity,
      category: productData.category,
      is_stock_managed: productData.is_stock_managed,
      benefits: productData.benefits,
      faqs: productData.faqs,
      low_stock_threshold: productData.low_stock_threshold,
      weight: productData.weight,
      dimensions: productData.dimensions,
      tags: productData.tags,
      is_visible: productData.is_visible,
      status: productData.status,
      currency: productData.currency,
      media_urls: safeMediaUrls,
      shop_id: shopId || null,
      organization_id: organizationId,
      form_id: productData.form_id || null
    };
    
    console.log('[addProduct] Inserting product with details:');
    console.log('- shop_id:', product.shop_id);
    console.log('- organization_id:', product.organization_id); 
    console.log('- form_id:', product.form_id);
    console.log('- Images count:', product.media_urls?.length || 0);
    console.log('- Image URLs:', product.media_urls);
    
    // Insert product with all parameters
    const { data, error } = await supabase
      .from('products')
      .insert([product])
      .select()
      .single();
    
    if (error) {
      console.error('[addProduct] Error adding product:', error);
      throw error;
    }
    
    console.log('[addProduct] Product added successfully:', {
      id: data.id,
      name: data.name,
      mediaUrlsCount: data.media_urls ? data.media_urls.length : 0,
      mediaUrls: data.media_urls
    });
    
    return data;
  } catch (error) {
    console.error('[addProduct] Failed to add product:', error);
    throw error;
  }
};
